import { Reason } from "./types";

/**
 * Item 29: embaralha os motivos a cada abertura, com "Outro" sempre por último.
 * `reasonPositions` = ids na ordem exibida (posição = índice + 1), contrato L14 do BE.
 */
export function orderForDisplay(reasons: Reason[], random: () => number = Math.random) {
  const rest = reasons.filter((r) => !r.isOther);
  for (let i = rest.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [rest[i], rest[j]] = [rest[j], rest[i]];
  }
  const ordered = [...rest, ...reasons.filter((r) => r.isOther)];
  return { ordered, reasonPositions: ordered.map((r) => r.id) };
}
